<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important;" class="main">
    <v-flex xs12 style="overflow-y: hidden;">
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="startProduction" class="breadCrumb">
        Production
      </v-btn>
      <v-btn @click="selectSupplier(currentSupplier)" v-if="currentSupplier" class="breadCrumb">
        {{ currentSupplier.name }}
      </v-btn>
      <v-btn @click="selectField(currentField)" v-if="currentField" class="breadCrumb">
        {{ currentField.address.name && currentField.address.name !== '' ? currentField.address.name : currentField.address.text }}
      </v-btn>
      <div v-if="showNextPalletNumber" class="nextPalletNumberTitle">
        {{ palletTitleRight() }}
      </div>

      <div style="float: right;">
        <v-btn @click="gotoLoadingOverview()" v-if="currentField && !showPallet" :disabled="overview || !isConnected" class="overviewBtn">
          Overview
        </v-btn>
        <v-btn @click="selectPlanned()" v-if="currentField && !showPallet" :disabled="!produced && !overview" class="plannedBtn">
          Planned
        </v-btn>
        <v-btn @click="selectProduced()" v-if="currentField && !showPallet" :disabled="(produced && !overview) || !isConnected" class="producedBtn">
          Produced
        </v-btn>
        <v-btn @click="createNewPallet()" v-if="currentField && !showPallet" :disabled="overview || !isConnected" class="createPallet">
          Create pallet
        </v-btn>
      </div>
      <div style="height: 10px;"></div>
    </v-flex>
    <ProductionReport ref="productionReport" v-show="showLoadingOverview"/>
    <v-container fluid py-2 px-3 v-show="showSupplierList" class="supplierButtons">
      <v-layout style="max-height: calc(100vh - 190px);">
        <v-flex xs12 style="overflow-y: auto;">
          <v-flex xs12 v-for="(supplier, i) in suppliers" :key="i" :style="'height: ' + Math.min(20, Math.max(6, 65 / suppliers.length)) + 'vh; margin-bottom: ' + (Math.max(0.5, 8 / suppliers.length)) + 'vh !important;'" class="supplierButton">
            <v-btn @click="selectSupplier(supplier)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / suppliers.length)) + 'vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - (5 * suppliers.length), 14), 25) + 'pt !important;'"><v-icon :style="supplierIconStyle(supplier)">error</v-icon>{{ supplier.name }}</v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-show="showFieldList" class="fieldButtons">
      <v-layout style="max-height: calc(100vh - 190px);">
        <v-flex xs12 style="overflow-y: auto;">
          <div v-for="(field, i) in fields" :key="i" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / fields.length)) + 'vh; margin-bottom: ' + (Math.max(0.5, 8 / fields.length)) + 'vh !important;'">
            <v-btn @click="selectField(field)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / fields.length)) + 'vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - ( 5 * fields.length), 8), 13) + 'pt !important;'"><v-icon :style="fieldIconStyle(field)">error</v-icon><div v-html="fieldNameAddress(field)"></div></v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-show="showPalletList" class="palletListContainer">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <div class="categoryButtonHeader">
            <table class="categoryButtonHeader">
              <tr>
                <td style="width: 38%;">Category</td>
                <td style="text-align: right; width: 14%;">Labelled</td>
                <td style="text-align: right; width: 14%;">Remaining</td>
                <td style="text-align: right; width: 14%;">Pallets</td>
                <td style="text-align: right; padding-right: 60px;">Deadline</td>
              </tr>
            </table>
          </div>
          <v-expansion-panel v-model="expansionSpecial" style="margin-top: 5px;" v-if="specialPalletGroup">
            <v-expansion-panel-content>
              <table slot="header">
                <tr>
                  <td style="width: 38%;">{{ specialPalletGroup.category.displayLabel }}</td>
                  <td style="width: 14%; text-align: right; padding-right: 0.7%;">{{ specialPalletGroup.category.id > 0 ? getLabelledAmount(specialPalletGroup.category) : '' }}</td>
                  <td style="width: 14%; text-align: right; padding-right: 1.2%;">{{ specialPalletGroup.category.id > 0 ? getRemainingAmount(specialPalletGroup.category) : '' }}</td>
                  <td style="width: 14%; text-align: right;">{{ specialPalletGroup.pallets.length + ' pallet' + (specialPalletGroup.pallets.length > 1 ? 's' : '') }}</td>
                  <td style="text-align: right; padding-right: 20px;">{{ specialPalletGroup.deadline }}</td>
                </tr>
              </table>
              <div style="padding: 0 15px 35px 15px;">
                <v-data-table :headers="headers" :items="specialPalletGroup.pallets" hide-actions style="overflow-y: auto;">
                  <template v-slot:headers="props">
                    <tr>
                      <th v-for="header in props.headers" :key="header.text" class="text-xs-left">
                        <div v-html="header.text"></div>
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <tr @click="selectPallet(props.item)" class="selectable">
                      <td class="text-xs-left" style="width: 130px;">{{ props.item.plannedShipmentNumber }}</td>
                      <td class="text-xs-left" style="width: 130px;">{{ props.item.number }}</td>
                      <td class="text-xs-left" style="width: 150px;">{{ stateLabel(props.item.state) }}</td>
                      <td class="text-xs-left" style="width: 140px;">{{ props.item.half ? '&frac12;' : 'Standard' }}</td>
                      <td class="text-xs-left"><div v-html="categories(props.item)"></div></td>
                      <td class="text-xs-left" style="width: 200px;">{{ displayDate(props.item.contractorDate ? props.item.contractorDate : props.item.pickupDate) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <template v-for="(palletGroup, i) in unplannedPalletGroups" v-if="unplannedPalletGroups && unplannedPalletGroups.length > 0">
            <table class="unplannedPalletGroup" :key="i">
              <tr @click="selectPallet(palletGroup.pallets[0], palletGroup.category)">
                <td style="width: 38%;">{{ palletGroup.category.displayLabel }}</td>
                <td style="width: 14%; text-align: right; padding-right: 0.7%;">{{ palletGroup.category.id > 0 ? getLabelledAmount(palletGroup.category) : '' }}</td>
                <td style="width: 12%; text-align: right; padding-right: 1.2%;">{{ palletGroup.category.id > 0 ? getRemainingAmount(palletGroup.category) : '' }}</td>
                <td style="width: 16%; text-align: right; padding-right: 35px;">{{ palletGroup.category.id > 0 ? getEstimatedNumberOfPallets(palletGroup.category) : '' }}</td>
                <td style="text-align: right; padding-right: 20px;">{{ palletGroup.deadline }}</td>
              </tr>
            </table>
          </template>
          <v-expansion-panel v-model="expansionMixed" style="margin-top: 5px;" v-if="plannedPalletGroup">
            <v-expansion-panel-content>
              <table slot="header">
                <tr>
                  <td style="width: 38%;">{{ plannedPalletGroup.category.displayLabel }}</td>
                  <td style="width: 14%; text-align: right; padding-right: 0.7%;">{{ plannedPalletGroup.category.id > 0 ? getLabelledAmount(plannedPalletGroup.category) : '' }}</td>
                  <td style="width: 14%; text-align: right; padding-right: 1.2%;">{{ plannedPalletGroup.category.id > 0 ? getRemainingAmount(plannedPalletGroup.category) : '' }}</td>
                  <td style="width: 14%; text-align: right;">{{ plannedPalletGroup.pallets.length + ' pallet' + (plannedPalletGroup.pallets.length > 1 ? 's' : '') }}</td>
                  <td style="text-align: right; padding-right: 20px;">{{ plannedPalletGroup.deadline }}</td>
                </tr>
              </table>
              <div style="padding: 0 15px 35px 15px;">
                <v-data-table :headers="headers" :items="plannedPalletGroup.pallets" hide-actions style="overflow-y: auto;">
                  <template v-slot:headers="props">
                    <tr>
                      <th v-for="header in props.headers" :key="header.text" class="text-xs-left">
                        <div v-html="header.text"></div>
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <tr @click="selectPallet(props.item)" class="selectable">
                      <td class="text-xs-left" style="width: 130px;">{{ props.item.plannedShipmentNumber }}</td>
                      <td class="text-xs-left" style="width: 130px;">{{ props.item.number }}</td>
                      <td class="text-xs-left" style="width: 150px;">{{ stateLabel(props.item.state) }}</td>
                      <td class="text-xs-left" style="width: 140px;">{{ props.item.half ? '&frac12;' : 'Standard' }}</td>
                      <td class="text-xs-left"><div v-html="categories(props.item)"></div></td>
                      <td class="text-xs-left" style="width: 200px;">{{ displayDate(props.item.contractorDate ? props.item.contractorDate : props.item.pickupDate) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <div style="padding-top: 20vh; width: 100%; text-align: center; font-size: 20px;" v-show="palletGroups.length === 0">No pallets found</div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-if="showPallet" class="palletListContainer palletContainer">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <Panel :title="'Pallet' + (currentPallet.number ? ' #' + currentPallet.number : '')" :title-right="stateLabel(currentPallet.state)" no-margin="true" class="palletPanel" :key="palletUpdateCounter">
            <v-flex xs12 pa-3 v-if="showPalletComment">
              <v-flex xs12 pa-3 class="commentBox">{{ currentPallet.comment }}</v-flex>
            </v-flex>
            <v-flex xs12 v-if="!hasPalletItems" pa-3>
            </v-flex>
            <v-flex xs12 px-2>
              <table style="margin-left: 10px;">
                <tr>
                  <td style="padding-right: 60px; padding-top: 10px;" class="header">&frac12; pallet</td>
                  <td style="padding-top: 12px;">
                    <div class="header" style="font-weight: normal;" v-if="currentPallet.plannedPalletId">{{ currentPallet.half ? 'Yes' : 'No' }}</div>
                    <v-checkbox color="teal" v-model="currentPallet.half" v-if="!currentPallet.plannedPalletId" :disabled="!isInProduction" style="margin-left: -2px; padding-top: 0 !important;"></v-checkbox>
                  </td>
                </tr>
              </table>
            </v-flex>
            <v-flex xs12 v-if="hasPalletItems" pa-3>
              <table class="palletItems">
                <tr>
                  <th style="width: 80px;" v-if="showColorColumn(currentPallet)">Color</th>
                  <th style="width: 50px;"></th>
                  <th>Category</th>
                  <th style="width: 100px;">Amount</th>
                  <th style="width: 100px;">Produced</th>
                  <th style="width: 75px;" v-if="isInProduction"></th>
                </tr>
                <tr v-for="(item, i) in currentPallet.items.filter(item => !item.deleted)" v-bind:key="item.id">
                  <td v-if="showColorColumn(currentPallet)">
                    <div v-if="item.category && item.category.id > 0 && !(item.category.color.secondColor && item.category.color.secondColor !== '')" :style="'width: 25px; height: 25px; background-color: #' + item.category.color.color + '; border: 1px solid #cccccc; display: table-cell;'"></div>
                    <div v-if="item.category && item.category.id > 0 && item.category.color.secondColor && item.category.color.secondColor !== ''" :style="'width: 25px; height: 25px; background: repeating-linear-gradient(-45deg, #' + item.category.color.color + ', #' + item.category.color.color + ' 3px, #' + item.category.color.secondColor + ' 3px, #' + item.category.color.secondColor + ' 6px); border: 1px solid #cccccc; display: table-cell;'"></div>
                  </td>
                  <td>
                    <v-icon v-if="item.category && item.category.image" class="tag" @click="showCategoryImage(item.category.image)">fa-tag</v-icon>
                    <v-icon v-if="isInProduction && i !== 0 && (item.category === null || item.id <= 0)" @click="confirmDeletePalletItem(item)" title="Delete">delete</v-icon>
                  </td>
                  <td v-if="!item.manual && item.category">{{ item.category.displayLabel + getOptionsAsString(item) }}</td>
                  <td v-if="item.manual">
                    <div v-if="!isInProduction">{{ item.category && item.category.id > 0 ? item.category.displayLabel : item.categoryName }}</div>
                    <table class="noPadding category">
                      <tr>
                        <td :style="'width: ' + (item.category && item.category.id > 0 ? '100%;' : '100px;')">
                          <div class="categoryInput" v-if="isInProduction && fieldCategory && fieldCategory.categories.length > 0">
                            <v-select :items="fieldCategory.categories" v-model="item.category" return-object>
                              <template slot="selection" slot-scope="data">
                                <div class="category" style="padding-top: 10px;">{{ data.item.displayLabel }}</div>
                              </template>
                              <template slot="item" slot-scope="data">
                                <div class="category">{{ data.item.displayLabel }}</div>
                              </template>
                            </v-select>
                          </div>
                        </td>
                        <td>
                          <div class="categoryInput" v-if="isInProduction && (!item.category || item.category.id === 0)">
                            <v-text-field v-model="item.categoryName" solo/>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="text-align: right; padding-right: 50px;">{{ item.plannedAmount }}</td>
                  <td style="text-align: right; padding-right: 40px;" v-if="isNotStarted || !isInProduction">{{ item.amount }}</td>
                  <td style="padding-right: 30px; padding-top: 10px;" v-if="!(isNotStarted || !isInProduction)">
                    <div class="amountInput" @click="openAmountDialog(item.id, item, i)">{{ amounts[item.id] }}</div>
                  </td>
                  <td style="text-align: right; padding-top: 8px;" v-if="isInProduction">
                    <div class="saveItemButton">
                      <v-btn @click="savePalletItem(currentPallet, item)" :disabled="isSavePalletItemButtonDisabled(item)" :key="inputKeys[i]" style="margin-top: 5px;">
                        <v-icon>done</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </table>
              <v-dialog v-model="amountDialog" width="70vh" content-class="numberPadDialog" attach=".palletPanel" v-if="!(isNotStarted || !isInProduction)" persistent>
                <div class="numberPadDialogContainer">
                  <table class="numberPad" style="width: 100%;">
                    <tr>
                      <td colspan="3"><div class="numberPadValue">{{ amounts[itemId] }}</div></td>
                      <td rowspan="5" class="wide"><div class="saveAmountBtn" @click="closeAmountDialog"><v-icon>done</v-icon></div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
                      <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
                      <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
                      <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
                      <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
                      <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
                      <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="clear()">Clr</div></td>
                      <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
                      <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
                    </tr>
                  </table>
                </div>
              </v-dialog>
              <v-dialog v-model="completePalletDialog" :width="changePalletNumber ? '70vh' : '500px'" content-class="numberPadDialog" attach=".palletPanel" v-if="!(isNotStarted || !isInProduction)">
                <div class="numberPadDialogContainer">
                  <div v-if="!changePalletNumber" style="padding: 5px;">
                    <table class="completePallet" style="width: 100%;">
                      <tr>
                        <td style="padding-bottom: 20px;">
                          <div class="tabletBtn" style="height: 100px; font-size: 24px; line-height: 100px;" @click="endPalletProduction">Complete pallet {{ currentPalletNumber }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="tabletBtn" @click="startChangePalletNumber">Change pallet number</div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="tabletBtn" @click="cancelCompletePallet">Cancel</div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <table class="numberPad" style="width: 100%;" v-if="changePalletNumber">
                    <tr>
                      <td colspan="3"><div class="numberPadValue">{{ palletNumberPrefix }}{{ palletNumberSequence }}</div></td>
                      <td rowspan="5" class="wide"><div class="saveAmountBtn" @click="savePalletNumber"><v-icon>done</v-icon></div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="palletNumberClick(1)">1</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(2)">2</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(3)">3</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="palletNumberClick(4)">4</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(5)">5</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(6)">6</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="palletNumberClick(7)">7</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(8)">8</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(9)">9</div></td>
                    </tr>
                    <tr>
                      <td><div class="numberBtn" @click="clearPalletNumber()">Clr</div></td>
                      <td><div class="numberBtn" @click="palletNumberClick(0)">0</div></td>
                      <td><div class="numberBtn" @click="backspacePalletNumber()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
                    </tr>
                  </table>
                </div>
              </v-dialog>
            </v-flex>
            <v-flex xs12 sm5 text-xs-left>
              <div class="palletButtonsLeft">
                <v-btn @click="selectField(currentField)" class="back">Back</v-btn>
                <v-btn @click="addPalletItem()" class="addCategory" :disabled="!isInProduction" style="margin-left: 10px !important;">Add category</v-btn>
              </div>
            </v-flex>
            <v-flex xs12 sm7 text-xs-right>
              <div class="startPalletButton" v-if="isNotStarted">
                <v-btn @click="startPalletProduction">Start production</v-btn>
              </div>
              <div class="endPalletButton" v-if="isInProduction">
                <v-btn @click="cancelPalletProduction">Cancel production</v-btn>
                <v-btn @click="openCompletePalletDialog" :disabled="isEndPalletButtonDisabled()" style="margin-left: 10px !important;">Pallet completed</v-btn>
              </div>
            </v-flex>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-if="showProductionReport">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <table class="productionReport">
            <tr>
              <th>Produced</th>
              <th>Pallet</th>
              <th>Category</th>
              <th style="text-align: right;" v-if="!produced">Pallets</th>
              <th style="text-align: right;" v-if="!produced">Per pallet</th>
              <th style="text-align: right;">Amount</th>
              <th>Supplier</th>
              <th>Field</th>
            </tr>
            <template v-for="(report) in productionReportByDate.dates">
              <tr v-for="(line) in report.lines" v-bind:key="line.key" :class="(report.rowIndex % 2 === 0 ? 'evenByDate' : 'oddByDate') + (report.firstInRow && line.lineIndex === 0 ? ' dateChanged' : '')">
                <td class="main">{{ report.date !== '0000-00-00 00:00' && report.date !== '9999-12-31 23:59' ? report.date : '' }}</td>
                <td class="main">{{ line.palletNumber }}</td>
                <td class="main"><div v-html="line.categories"></div></td>
                <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="line.totalAmount"></div></td>
                <td class="main">{{ line.supplier.name }}</td>
                <td class="main">{{ line.field.address && line.field.address.name && line.field.address.name !== '' ? line.field.address.name : line.field.address ? line.field.address.text : '' }}</td>
              </tr>
            </template>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="confirmDeletePalletItemDialog" attach=".palletContainer" width="35vw" v-if="showPallet">
      <v-card pa-5>
        <v-card-title class="headline">Delete category</v-card-title>
        <v-card-text>Are you sure you want to delete this category?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deletePalletItem" class="bw-3">Yes</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="confirmDeletePalletItemDialog = false" class="bw-3">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCategoryImageDialog" attach=".palletContainer" width="80vw" class="showCategoryImageDialog" v-if="showPallet">
      <img :src="categoryImageUrl" style="width: 100%; border: 5px solid white; border-radius: 5px;" @click="showCategoryImageDialog = false"/>
    </v-dialog>
    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from './Panel'
import PalletItems from './PalletItems'
import ProductionReport from './ProductionReport'
import DateUtil from '@/assets/javascript/dateutil'
import NumberUtil from '@/assets/javascript/numberutil'
import ErrorDialog from '../components/ErrorDialog'
import axios from 'axios'
import uuid from 'uuid/v4'

export default {
  name: 'TodoProduction',
  components: { Panel, PalletItems, ProductionReport, ErrorDialog },
  data () {
    return {
      currentSupplier: null,
      currentField: null,
      currentCategory: null,
      currentPallet: null,
      fields: [],
      palletGroups: [],
      amounts: {},
      inputKeys: [],
      expansionSpecial: null,
      expansionMixed: null,
      headers: [
        { text: 'Shipment', value: 'plannedShipmentNumber', sortable: false },
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'State', value: 'stateLabel', sortable: false },
        { text: 'Pallet size', value: 'half', sortable: false },
        { text: 'Categories', sortable: false },
        { text: 'Deadline', sortable: false }
      ],
      itemId: null,
      currentItemId: null,
      currentIndex: null,
      amountDialog: false,
      startPalletProductionWarningDialog: false,
      startPalletProductionWarningMessage: '',
      showCategoryImageDialog: false,
      categoryImageUrl: '',
      itemToDelete: null,
      confirmDeletePalletItemDialog: false,
      fieldCategories: null,
      fieldCategory: null,
      produced: false,
      productionReportByDate: null,
      productionReportLoaded: false,
      currentPalletNumber: null,
      completePalletDialog: false,
      changePalletNumber: false,
      palletNumberPrefix: '',
      palletNumberSequence: 0,
      palletUpdateCounter: 1,
      pallets: [],
      overview: false
    }
  },
  created: function () {
    this.loadPalletNumberSequence()
    this.loadSuppliers()
    this.loadContractorPallets()
    this.loadFieldCategories()
    this.loadFieldStatuses()
    this.loadPallets()
    this.startProduction()
    document.addEventListener('keydown', this.keydownHandler)
  },
  destroyed: function () {
    document.removeEventListener('keydown', this.keydownHandler)
  },
  computed: {
    allPallets: function () {
      return this.$store.state.contractor.pallets
    },
    suppliers: function () {
      return this.$store.state.contractor.suppliers
    },
    fieldStatuses: function () {
      return this.$store.state.contractor.fieldStatuses
    },
    showSupplierList: function () {
      return !this.showFrontPage && !this.currentSupplier
    },
    showFieldList: function () {
      return !this.showSupplierList && !this.currentField
    },
    showPalletList: function () {
      return !this.showSupplierList && !this.showFieldList && !this.currentPallet && !this.produced && !this.showLoadingOverview
    },
    showPallet: function () {
      return !this.showSupplierList && !this.showFieldList && this.currentPallet
    },
    showProductionReport: function () {
      return this.currentField && this.produced && this.productionReportLoaded
    },
    showLoadingOverview: function () {
      return this.overview
    },
    isNotStarted: function () {
      return this.palletUpdateCounter && this.currentPallet && (!this.currentPallet.state || this.currentPallet.state === 'PLANNED')
    },
    isInProduction: function () {
      return this.palletUpdateCounter && this.currentPallet && this.currentPallet.state === 'IN_PRODUCTION'
    },
    showPalletComment: function () {
      return this.currentPallet && this.currentPallet.comment
    },
    isConnected: function () {
      return this.$store.getters['session/isConnected'] && this.isOnline
    },
    hasPalletItems: function () {
      if (this.currentPallet && this.currentPallet.items && this.currentPallet.items.length > 0) {
        for (let item of this.currentPallet.items) {
          if (item.id <= 0 || item.deleted === false) {
            return true
          }
        }
      }
      return false
    },
    specialPalletGroup: function () {
      if (this.palletGroups && this.palletGroups.length > 0 && this.palletGroups[0].category.specialCategory) {
        return this.palletGroups[0]
      }
      return null
    },
    plannedPalletGroup: function () {
      if (this.palletGroups && this.palletGroups.length > 0 && this.palletGroups[this.palletGroups.length - 1].category.plannedCategory) {
        return this.palletGroups[this.palletGroups.length - 1]
      }
      return null
    },
    unplannedPalletGroups: function () {
      if (this.palletGroups && this.palletGroups.length > 0) {
        let unplannedPalletGroups = []
        for (let pg of this.palletGroups) {
          if (pg.category.id > 0 && this.getLabelledAmount(pg.category)) {
            unplannedPalletGroups.push(pg)
          }
        }
        return unplannedPalletGroups
      }
      return null
    },
    showNextPalletNumber: function () {
      return this.palletUpdateCounter && this.currentPallet && (!this.currentPallet.number || this.currentPallet.number === '') && this.currentPallet.state === 'IN_PRODUCTION' && !this.completePalletDialog
    },
    nextPalletNumber: function () {
      if (this.currentPallet) {
        let supplierNumber = this.currentPallet.supplier.number
        let sequence = this.$store.getters['contractor/getPalletNumberSequence']
        return supplierNumber + sequence
      }
      return null
    }
  },
  methods: {
    loadPalletNumberSequence: function () {
      let queueSize = this.$store.getters['status/getNumberOfCommandsInQueue']
      if (queueSize === 0) {
        this.$store.dispatch('contractor/loadPalletNumberSequence', { userName: this.$store.state.session.userName })
      }
    },
    loadSuppliers: function () {
      this.$store.dispatch('contractor/loadSuppliers')
    },
    loadFieldStatuses: function () {
      this.$store.dispatch('contractor/loadFieldStatuses')
    },
    loadContractorPallets: function () {
      this.$store.dispatch('contractor/loadPallets')
    },
    loadFieldCategories: function () {
      this.fieldCategories = []
      axios.get('/backend/rest/field/category/contractor')
        .then(response => {
          this.fieldCategories = response.data
          // Save to local storage
          localStorage.setItem('FieldCategories', JSON.stringify(this.fieldCategories))
        })
        .catch(() => {
          // Load from local storage
          // console.log('Failed to get field categories, using cached data')
          let fc = localStorage.getItem('FieldCategories')
          if (fc) {
            this.fieldCategories = JSON.parse(fc)
          }
        })
    },
    loadPallets: function () {
      let jsonPallets = localStorage.getItem('PalletsInProduction')
      if (jsonPallets) {
        this.pallets = JSON.parse(jsonPallets)
      } else {
        this.pallets = []
      }
    },
    gotoFrontPage: function () {
      this.currentSupplier = null
      this.currentField = null
      this.currentPallet = null
      this.$parent.$parent.gotoHome()
    },
    startProduction: function () {
      this.currentSupplier = null
      this.currentField = null
      this.currentPallet = null
      this.overview = false
    },
    selectSupplier: function (supplier) {
      this.currentSupplier = supplier
      this.currentField = null
      this.currentPallet = null
      this.fields = supplier.fields
      this.overview = false
    },
    selectField: function (field) {
      this.currentField = field
      this.overview = false
      this.currentPallet = null
      this.fieldCategory = null
      if (this.fieldCategories && this.fieldCategories.length > 0) {
        for (let fc of this.fieldCategories) {
          if (fc.field.id === field.id) {
            let fieldCategory = JSON.parse(JSON.stringify(fc))
            fieldCategory.categories.splice(0, 0, {
              id: 0,
              displayLabel: ''
            })
            this.fieldCategory = fieldCategory
            break
          }
        }
      }
      this.filterPallets()
      this.loadFieldStatuses()
    },
    filterPallets: function () {
      this.loadPallets()
      let palletGroups = {}

      // Add the groups for all labelled categories
      let maxGroupId = 0
      if (this.currentField && this.currentField.categories) {
        for (let c of this.currentField.categories) {
          // console.log('Category: ' + JSON.stringify(c, null, 2))
          let palletGroup = {
            category: c,
            deadline: null,
            pallets: []
          }
          palletGroups[c.id] = palletGroup
          let pallet = this.createPalletForCategory(c)
          palletGroup.pallets.push(pallet)
          if (c.id > maxGroupId) {
            maxGroupId = c.id
          }
        }
      }

      // Add the special pallets
      let specialCategory = {
        id: 0,
        specialCategory: true,
        displayLabel: 'Special pallets'
      }

      // Add the planned pallets
      let plannedCategory = {
        id: maxGroupId + 1,
        plannedCategory: true,
        displayLabel: 'Planned pallets'
      }
      if (this.allPallets && this.currentField && this.currentSupplier) {
        for (let p of this.allPallets) {
          if (((p.field && p.field.id === this.currentField.id) || (!p.field && p.supplier && p.supplier.id === this.currentSupplier.id && this.fieldHasPalletContent(p))) && (p.state === 'PLANNED' || p.state === 'IN_PRODUCTION')) {
            let specialPallet = p.special || (p.items && p.items.length > 1)
            let groupId = specialPallet ? specialCategory.id : plannedCategory.id
            let palletGroup = palletGroups[groupId]
            if (!palletGroup) {
              palletGroup = {
                category: specialPallet ? specialCategory : plannedCategory,
                deadline: null,
                pallets: []
              }
              palletGroups[groupId] = palletGroup
            }
            p.number = ''
            p.state = 'PLANNED'
            let produced = false
            for (let pip of this.pallets) {
              if (pip.plannedPalletId && pip.plannedPalletId === p.id) {
                if (pip.state === 'IN_PRODUCTION') {
                  p.number = pip.number
                  p.state = 'IN_PRODUCTION'
                } else {
                  produced = true
                }
              }
            }
            if (!produced) {
              palletGroup.pallets.push(p)
            }
          }
        }
      }

      // Do we have pallets in production which is no longer planned
      for (let pip of this.pallets) {
        if (pip.plannedPalletId && pip.state === 'IN_PRODUCTION') {
          let found = false
          for (let p of this.allPallets) {
            if (p.id === pip.plannedPalletId) {
              found = true
              break
            }
          }
          if (!found) {
            let specialPallet = pip.special || (pip.items && pip.items.length > 1)
            let groupId = specialPallet ? specialCategory.id : plannedCategory.id
            let palletGroup = palletGroups[groupId]
            if (!palletGroup) {
              palletGroup = {
                category: specialPallet ? specialCategory : plannedCategory,
                deadline: null,
                pallets: []
              }
              palletGroups[groupId] = palletGroup
            }
            palletGroup.pallets.push(pip)
          }
        }
      }

      // Sort the pallets
      let sortedPalletGroups = []
      for (let i in palletGroups) {
        palletGroups[i].pallets.sort(function (p1, p2) {
          let deadline1 = p1.contractorDate ? p1.contractorDate : p1.pickupDate ? p1.pickupDate : '9999-99-99'
          let deadline2 = p2.contractorDate ? p2.contractorDate : p2.pickupDate ? p2.pickupDate : '9999-99-99'
          let res = deadline1.localeCompare(deadline2)
          if (res === 0) {
            res = (p1.plannedShipmentNumber + '').localeCompare((p2.plannedShipmentNumber + ''))
          }
          if (res === 0) {
            res = (p1.state + '').localeCompare((p2.state + ''))
          }
          if (res === 0) {
            res = (p1.number + '').localeCompare((p2.number + ''))
          }
          return res
        })
        palletGroups[i].deadline = palletGroups[i].pallets[0] ? this.displayDate(palletGroups[i].pallets[0].contractorDate ? palletGroups[i].pallets[0].contractorDate : palletGroups[i].pallets[0].pickupDate) : ''
        sortedPalletGroups.push(palletGroups[i])
      }

      // Sort the pallet groups
      sortedPalletGroups.sort(function (pg1, pg2) {
        if (pg1.category.id === pg2.category.id) {
          return 0
        } else if (pg1.category.id === specialCategory.id) {
          return -1
        } else if (pg2.category.id === specialCategory.id) {
          return 1
        } else if (pg1.category.id === plannedCategory.id) {
          return 1
        } else if (pg2.category.id === plannedCategory.id) {
          return -1
        }
        return (pg1.category.sortableLabel + '').localeCompare((pg2.category.sortableLabel + ''))
      })

      this.palletGroups = sortedPalletGroups
    },
    fieldHasPalletContent: function (pallet) {
      let hasContent = true
      if (pallet && pallet.items) {
        for (let item of pallet.items) {
          if (item.category && this.getLabelledAmount(item.category) === '') {
            hasContent = false
            break
          }
        }
      }
      return hasContent
    },
    createPalletForCategory: function (category) {
      let pallet = {
        id: 0,
        field: {
          id: this.currentField.id
        },
        supplier: {
          id: this.currentSupplier.id,
          number: this.currentSupplier.number,
          name: this.currentSupplier.name
        },
        items: [
          {
            id: 0,
            category: category,
            plannedAmount: category.palletAmount,
            amount: null
          }
        ]
      }
      return pallet
    },
    selectPallet: function (pallet, category = null) {
      this.currentCategory = category
      this.completePalletDialog = false
      this.changePalletNumber = false

      // Check if the pallet is already in production
      let palletSelected = null
      this.loadPallets()
      for (let p of this.pallets) {
        if (pallet.id > 0) {
          // Handle planned pallet
          if (p.plannedPalletId && p.plannedPalletId === pallet.id) {
            palletSelected = p
            break
          }
        } else {
          // Simple pallet based on category
          if (p.state !== 'PRODUCED' && pallet.field.id === p.field.id && pallet.items && pallet.items.length === 1 && p.items && p.items.length === 1 && pallet.items[0].category && p.items[0].category && pallet.items[0].category.id === p.items[0].category.id) {
            palletSelected = p
            break
          }
        }
      }
      if (palletSelected === null) {
        // Pallet is not in production, hence copy it
        if (pallet.state !== 'PLANNED' && (!pallet.items || pallet.items.length === 0)) {
          pallet.items = [
            {
              id: 0,
              uuid: uuid(),
              categoryName: '',
              plannedAmount: 0,
              amount: 0,
              manual: true
            }
          ]
        }
        palletSelected = JSON.parse(JSON.stringify(pallet))
        if (pallet.id > 0) {
          // The pallet is planned
          palletSelected.id = 0
          palletSelected.plannedPalletId = pallet.id
        }
      }
      this.currentPallet = palletSelected
      if (!this.currentPallet.field) {
        this.currentPallet.field = {
          id: this.currentField.id
        }
      }

      this.amounts = {}
      this.inputKeys = []
      for (let item of this.currentPallet.items) {
        this.amounts[item.id] = item.amount !== 0 ? item.amount : ''
        this.inputKeys.push(1)
      }
    },
    startPalletProduction: function () {
      // Make sure the pallet is not already started, e.g. by another
      // console.log('Start pallet production on id ' + this.currentPallet.id)
      this.$store.dispatch('contractor/startPallet', this.currentPallet)
      for (let item of this.currentPallet.items) {
        this.amounts[item.id] = item.amount !== 0 ? item.amount : ''
        this.inputKeys.push(1)
      }
      this.palletUpdateCounter++
    },
    cancelPalletProduction: function () {
      this.$store.dispatch('contractor/cancelPallet', this.currentPallet)
      this.filterPallets()

      if (this.currentCategory) {
        this.currentPallet = this.createPalletForCategory(this.currentCategory)
      } else {
        this.currentPallet = null
      }
    },
    endPalletProduction: function () {
      this.$store.dispatch('contractor/endPallet', this.currentPallet).finally(() => {
        this.currentPallet = null
        this.filterPallets()
        this.completePalletDialog = false
      })
    },
    savePalletItem: function (pallet, item) {
      let amount = this.amounts[item.id]
      item.amount = amount
      // console.log('Save pallet item ' + item.id + ' with amount ' + amount)
      this.$store.dispatch('contractor/savePalletItem', { pallet: this.currentPallet, item: item })
    },
    amountChanged: function (item, index) {
      let key = this.inputKeys[index] + 1
      this.$set(this.inputKeys, index, key)
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          if (item.category && item.category.id > 0) {
            categories += item.category.displayLabel
            categories += ', ' + item.plannedAmount + 'pcs.'
          } else {
            categories += item.categoryName
          }
          categories += this.getOptionsAsString(item)
        }
      }
      return categories
    },
    getOptionsAsString: function (item) {
      let getOptionsAsString = ''
      if (item.options && item.options.length > 0) {
        getOptionsAsString += ' ('
        for (let i = 0; i < item.options.length; i++) {
          if (i > 0) {
            getOptionsAsString += ', '
          }
          getOptionsAsString += item.options[i].name
        }
        getOptionsAsString += ')'
      }
      return getOptionsAsString
    },
    isSavePalletItemButtonDisabled: function (item) {
      let disabled = this.isNotStarted
      if (!disabled && !NumberUtil.isZeroOrPositiveInteger(this.amounts[item.id])) {
        disabled = true
      }
      if (!disabled) {
        for (let it of this.currentPallet.items) {
          if (it.id === item.id) {
            if (NumberUtil.isZeroOrPositiveInteger(it.amount) && NumberUtil.isZeroOrPositiveInteger(this.amounts[item.id]) && Number(it.amount) === Number(this.amounts[item.id])) {
              disabled = true
            }
            break
          }
        }
      }
      if ((!item.category || item.category.id === 0) && item.categoryName.trim() === '') {
        disabled = true
      }
      return disabled
    },
    isEndPalletButtonDisabled: function () {
      let disabled = this.isNotStarted || this.currentPallet.items == null || this.currentPallet.items.length === 0
      if (!disabled) {
        for (let item of this.currentPallet.items) {
          if (item.deleted) {
            continue
          }
          if (!NumberUtil.isZeroOrPositiveInteger(this.amounts[item.id]) || !NumberUtil.isZeroOrPositiveInteger(item.amount) || !this.isSavePalletItemButtonDisabled(item)) {
            disabled = true
            break
          }
          if (!item.category && item.categoryName.trim() === '') {
            disabled = true
          }
        }
      }
      return disabled
    },
    stateLabel: function (state) {
      switch (state) {
        case 'PLANNED': return 'Planned'
        case 'IN_PRODUCTION': return 'In production'
        case 'PRODUCED': return 'Produced'
        case 'READY_FOR_PICKUP': return 'Ready for pickup'
        case 'IN_TRANSPORT': return 'In transport'
        case 'REPACKED': return 'Repacked'
        case 'DELIVERED': return 'Delivered'
      }
      return ''
    },
    palletTitleRight: function () {
      if (this.currentPallet) {
        let title = ''
        if (this.showNextPalletNumber) {
          title += 'Next pallet number is ' + this.nextPalletNumber
        }
        return title
      }
      return ''
    },
    openAmountDialog: function (itemId, currentItem, currentIndex) {
      this.itemId = itemId
      this.currentItem = currentItem
      this.currentIndex = currentIndex
      this.amountDialog = true
    },
    closeAmountDialog: function () {
      this.amountDialog = false
    },
    numberClick: function (number) {
      let value = this.amounts[this.itemId]
      if (value === null) {
        value = 0
      }
      value = value + '' + number
      this.amounts[this.itemId] = Number(value)
      this.amountChanged(this.currentItem, this.currentIndex)
    },
    clear: function () {
      this.amounts[this.itemId] = ''
      this.amountChanged(this.currentItem, this.currentIndex)
    },
    backspace: function () {
      let val = '' + this.amounts[this.itemId]
      if (val.length > 1) {
        let value = val.substring(0, val.length - 1)
        this.amounts[this.itemId] = Number(value)
        this.amountChanged(this.currentItem, this.currentIndex)
      } else {
        this.clear()
      }
    },
    palletNumberClick: function (number) {
      let value = this.palletNumberSequence
      if (value === null) {
        value = 0
      }
      value = value + '' + number
      this.palletNumberSequence = '' + Number(value)
      if (this.palletNumberSequence.length > 3) {
        this.palletNumberSequence = this.palletNumberSequence.substring(this.palletNumberSequence.length - 3, this.palletNumberSequence.length)
      }
      while (this.palletNumberSequence.length < 3) {
        this.palletNumberSequence = '0' + this.palletNumberSequence
      }
    },
    clearPalletNumber: function () {
      this.palletNumberSequence = '000'
    },
    backspacePalletNumber: function () {
      let val = '' + this.palletNumberSequence
      if (val.length > 1) {
        let value = val.substring(0, val.length - 1)
        this.palletNumberSequence = '' + Number(value)
        while (this.palletNumberSequence.length < 3) {
          this.palletNumberSequence = '0' + this.palletNumberSequence
        }
      } else {
        this.clearPalletNumber()
      }
    },
    supplierIconStyle: function (supplier) {
      let color = null
      if (supplier.firstPickupDate) {
        let minutesToDeadline = DateUtil.minutesToDate(supplier.firstPickupDate)
        if (minutesToDeadline < (24 * 60)) {
          color = '#FF6666'
        } else if (minutesToDeadline < (48 * 60)) {
          color = '#FFBB66'
        }
      }
      if (color) {
        return 'font-size: 36px; color: ' + color + '; margin-right: 15px; font-size: 120%;'
      }
      return 'width: 0; color: transparent;'
    },
    fieldIconStyle: function (field) {
      let color = null
      if (field.firstPickupDate) {
        let minutesToDeadline = DateUtil.minutesToDate(field.firstPickupDate)
        if (minutesToDeadline < (24 * 60)) {
          color = '#FF6666'
        } else if (minutesToDeadline < (48 * 60)) {
          color = '#FFBB66'
        }
      }
      if (color) {
        return 'font-size: 36px; color: ' + color + '; margin-right: 15px; font-size: 120%;'
      }
      return 'width: 0; color: transparent;'
    },
    createNewPallet: function () {
      this.currentCategory = null
      this.currentPallet = {
        id: 0,
        supplier: {
          id: this.currentSupplier.id,
          number: this.currentSupplier.number
        },
        field: {
          id: this.currentField.id
        },
        half: false,
        items: []
      }
      this.startPalletProduction()
    },
    addPalletItem: function () {
      let nextId = 0
      if (this.currentPallet.items && this.currentPallet.items.length > 0) {
        nextId = -this.currentPallet.items.length
      }
      let item = {
        id: nextId,
        uuid: uuid(),
        categoryName: '',
        plannedAmount: 0,
        amount: 0,
        manual: true
      }
      this.currentPallet.items.push(item)
      this.amounts[item.id] = ''
    },
    confirmDeletePalletItem (itemToDelete) {
      this.itemToDelete = itemToDelete
      this.confirmDeletePalletItemDialog = true
    },
    deletePalletItem: function () {
      this.itemToDelete.deleted = true
      // console.log('Delete pallet item ' + this.itemToDelete.id)
      this.$store.dispatch('contractor/deletePalletItem', { pallet: this.currentPallet, item: this.itemToDelete })
      this.confirmDeletePalletItemDialog = false
    },
    fieldNameAddress: function (field) {
      let nameAddress = ''
      if (field.address.name && field.address.name !== '') {
        nameAddress += '<div style="font-weight: bold; font-size: 110%;">' + field.address.name + '</div>'
        nameAddress += '<div style="font-weight: bold; font-size: 60% !important;">' + field.address.text + '</div>'
      } else {
        nameAddress += field.address.text
      }
      return nameAddress
    },
    showColorColumn: function (pallet) {
      if (pallet.items && pallet.items.length > 0) {
        for (let i in pallet.items) {
          if (pallet.items[i].category && pallet.items[i].category.id > 0) {
            return true
          }
        }
      }
      return false
    },
    showCategoryImage: function (imageUuid) {
      this.categoryImageUrl = '/backend/image/' + imageUuid
      this.showCategoryImageDialog = true
    },
    getLabelledAmount: function (category) {
      let labelledAmount = ''
      if (this.fieldStatuses && this.currentField && category) {
        for (let fieldStatus of this.fieldStatuses) {
          if (fieldStatus.id === this.currentField.id) {
            if (fieldStatus.categoryStatus) {
              for (let cs of fieldStatus.categoryStatus) {
                if (cs.id === category.id) {
                  labelledAmount = cs.labelled ? cs.labelled : ''
                  break
                }
              }
            }
            break
          }
        }
      }
      return labelledAmount
    },
    getRemainingAmount: function (category) {
      let remainingAmount = ''
      if (this.fieldStatuses && this.currentField && category) {
        for (let fieldStatus of this.fieldStatuses) {
          if (fieldStatus.id === this.currentField.id) {
            if (fieldStatus.categoryStatus) {
              for (let cs of fieldStatus.categoryStatus) {
                if (cs.id === category.id) {
                  remainingAmount = cs.remaining ? cs.remaining : '0'
                  break
                }
              }
            }
            break
          }
        }
      }
      return remainingAmount
    },
    getEstimatedNumberOfPallets: function (category) {
      let amountPerPallet = category.palletAmount
      let remainingAmount = this.getRemainingAmount(category)
      let estimatedNumberOfPallets = 0
      if (amountPerPallet && amountPerPallet > 0 && remainingAmount && remainingAmount > 0 && remainingAmount >= amountPerPallet) {
        estimatedNumberOfPallets = Math.floor(remainingAmount / amountPerPallet)
      }
      return estimatedNumberOfPallets + ' pallet' + (estimatedNumberOfPallets !== 1 ? 's' : '')
    },
    selectPlanned: function () {
      this.produced = false
      this.overview = false
    },
    selectProduced: function () {
      this.produced = true
      this.overview = false
      this.loadProductionReportByDate()
    },
    gotoLoadingOverview: function () {
      this.$refs.productionReport.hideBreadCrumb()
      this.$refs.productionReport.hideExcelButton()
      this.$refs.productionReport.hidePdfButton()
      this.$refs.productionReport.hideBreadCrumb()
      this.$refs.productionReport.setPadding(false)
      this.$refs.productionReport.filterSupplier = this.currentSupplier
      this.$refs.productionReport.goShipmentsForLoader()
      this.produced = false
      this.overview = true
    },
    loadProductionReportByDate () {
      this.productionReportLoaded = false
      axios.get('/backend/rest/production_report/by_date?produced=' + this.produced + '&userName=' + this.$store.state.session.userName)
        .then(response => {
          this.productionReportByDate = response.data
          this.productionReportLoaded = true
        })
    },
    startChangePalletNumber: function () {
      this.changePalletNumber = true
    },
    savePalletNumber: function () {
      this.currentPalletNumber = this.palletNumberPrefix + this.palletNumberSequence
      let sequence = '' + parseInt(this.currentPalletNumber.substring(2, 6))
      this.$store.dispatch('contractor/setPalletNumberSequence', { userName: this.$store.state.session.userName, sequence: sequence })
      this.changePalletNumber = false
    },
    openCompletePalletDialog: function () {
      if (this.currentPallet) {
        this.currentPalletNumber = this.nextPalletNumber
        this.palletNumberPrefix = this.currentPalletNumber.substring(0, 3)
        this.palletNumberSequence = this.currentPalletNumber.substring(3, 6)
        this.completePalletDialog = true
      }
    },
    cancelCompletePallet: function () {
      this.completePalletDialog = false
    },
    keydownHandler: function (event) {
      if (this.amountDialog) {
        if (event.key >= '0' && event.key <= '9') {
          this.numberClick(Number(event.key))
        } else if (event.key === 'Backspace') {
          this.backspace()
        } else if (event.key === 'Delete') {
          this.clear()
        } else if (event.key === 'Enter') {
          this.closeAmountDialog()
        }
      } else if (this.changePalletNumber) {
        if (event.key >= '0' && event.key <= '9') {
          this.palletNumberClick(Number(event.key))
        } else if (event.key === 'Backspace') {
          this.backspacePalletNumber()
        } else if (event.key === 'Delete') {
          this.clearPalletNumber()
        } else if (event.key === 'Enter') {
          this.savePalletNumber()
        }
      }
    },
    displayDate (date) {
      if (date && date.endsWith(' 00:00')) {
        return date.substring(0, date.lastIndexOf(' 00:00'))
      }
      return date
    }
  },
  watch: {
    allPallets (val) {
      if (this.currentField) {
        this.filterPallets()
      }
    }
  }
}
</script>

<style scoped>
  .header {
    font-size: 16px;
    font-weight: bold;
  }
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .palletItems {
    width: 100%;
    font-size: 10pt;
    border-collapse: collapse;
  }
  .palletItems td {
    border-top: 1px solid #DDDDDD;
    padding: 10px 5px;
  }
  .palletItems th {
    text-align: left;
    padding: 2px 5px;
    color: #606060;
    font-size: 14px;
  }
  .contractorAmount {
    font-size: 15px !important;
  }
  .palletButtonsLeft .v-btn.back {
    border-radius: 8px;
    height: 50px !important;
    width: 125px;
    font-size: 20px !important;
  }
  .palletButtonsLeft .v-btn.addCategory {
    border-radius: 8px;
    height: 50px !important;
    width: 190px;
    font-size: 20px !important;
  }
  .startPalletButton .v-btn,
  .endPalletButton .v-btn {
    border-radius: 8px;
    height: 50px !important;
    width: 240px;
    font-size: 20px !important;
  }
  .saveItemButton .v-btn {
    border-radius: 8px;
    height: 50px !important;
    width: 75px;
    min-width: 40px !important;
    padding: 0;
  }
  .saveItemButton .v-btn .v-icon {
    font-size: 36px !important;
  }
  .amountInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 75px;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .categoryInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    width: 90%;
    cursor: pointer;
    font-size: 20px;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .v-text-field>.v-input__control>.v-input__slot:after {
    border-color: currentcolor;
    border-style: solid;
    border-width: 5px;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }
  .readonly {
    cursor: default !important;
  }
  .numberPadDialog {
    box-shadow: none;
  }
  .numberPad {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
  }
  .numberPad tr {
    border: none;
  }
  .numberPad tr td {
    border: none;
    padding: 2px;
    text-align: right;
    width: 22%;
  }
  .numberPad tr td.wide {
    width: 34%;
  }
  .numberBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberBtn:hover {
    background-color: rgba(0, 62, 48, 0.87);
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .tabletBtn {
    width: 100%;
    height: 50px;
    text-align: center;
    vertical-align: center;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    background-color: #003d30;
    border-radius: 5px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .tabletBtn:hover {
    background-color: rgba(0, 62, 48, 0.87);
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberPadValue {
    border: 1px solid #004d40;
    border-radius: 10px;
    height: 10vh;
    width: 100%;
    cursor: pointer;
    font-size: 7vh;
    line-height: 10vh;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .saveAmountBtn {
    width: 100%;
    height: 52.5vh;
    text-align: center;
    vertical-align: center;
    padding-top: 20vh;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .saveAmountBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .palletListContainer .v-btn {
    border-radius: 5px;
  }
  .v-dialog__content .v-btn {
    border-radius: 5px !important;
  }
  .tag {
    color: #004d40;
    cursor: pointer;
  }
  table.category {
    width: 100%;
  }
  table.category tr td {
    border: none;
    padding: 0 10px 0 0;
  }
  div.categoryButtonHeader {
    padding: 5px 48px 0 24px;
    background-color: #003d30;
    border-radius: 5px;
    height: 42px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  div.categoryButtonHeader table {
    width: 100%;
    font-size: 110%;
    font-weight: bold;
    color: white;
  }
  div.category {
    font-size: 20px;
  }
  table.productionReport {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionReport th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionReport td.main {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  tr.odd {
    background-color: #ffffff;
  }
  tr.even {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.oddByDate {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.evenByDate {
    background-color: #ffffff;
  }
  tr.dateChanged {
    border-top: 2px solid #303030 !important;
  }
  .nextPalletNumberTitle {
    float: right;
    font-weight: bold;
    font-size: 12pt;
    font-style: normal;
    color: #004d40;
    padding-top: 8px;
    padding-right: 10px;
  }
  table.completePallet tr td {
    padding: 5px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoProduction.vue